import React from 'react';
import { Text, Flex, Checkbox } from '@marvelapp/ui';
import { SpecsPanel } from '@marvelapp/ui-internal';
import PanelPropertyItem from '../PanelPropertyItem';
export default function RowSettings(_a) {
    var heightAsGutterMultiple = _a.heightAsGutterMultiple, gutterHeight = _a.gutterHeight, isOverlayOn = _a.isOverlayOn, toggleOverlay = _a.toggleOverlay;
    return (React.createElement(SpecsPanel, { renderLink: function () { return (React.createElement(Checkbox, { isChecked: isOverlayOn, onChange: toggleOverlay, size: 16 },
            React.createElement(Text, { fontSize: 12, lineHeight: "16px" }, "Show overlay"))); }, title: "Rows" },
        React.createElement(Flex, { flexWrap: "wrap", marginBottom: -3 },
            React.createElement(PanelPropertyItem, { label: "Gutter" },
                gutterHeight,
                "px"),
            React.createElement(PanelPropertyItem, { fontFamily: 0, label: "Row Height" },
                heightAsGutterMultiple,
                " x Gutter"))));
}
